import { API_TYPE } from '@umu/umu-fetch';

export const HomeworkAPI = {
    GET_GESTURE_LIST: {
        url: `/uapi/v1/gesture-practice/element-detail`,
        type: API_TYPE.POST,
    },
    GET_GESTURE_DETAIL: {
        url: `/uapi/v1/gesture-practice`,
        type: API_TYPE.GET,
    },
    // 屏蔽
    POST_SWITCH_HOMEWORK_SHIELD: {
        url: `/uapi/v1/homework/shield`,
        type: API_TYPE.POST,
    },
    // 设为优秀作业
    POST_SWITCH_HOMEWORK_EXCELLENT: {
        url: `/uapi/v1/homework/set-excellent`,
        type: API_TYPE.POST,
    },
};
